var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page", attrs: { id: "memberDebtorList" } }, [
    _c(
      "div",
      { staticClass: "page-content" },
      [
        _c("div", { staticClass: "layoutTop" }),
        _vm._v(" "),
        _c("f7-searchbar", {
          staticClass: "search",
          attrs: {
            "cancel-link": "Cancel",
            "search-list": "#add-member-group-member-list",
            placeholder: _vm.$t("creation_forms.srch_in_list"),
          },
        }),
        _vm._v(" "),
        _c(
          "f7-list",
          { attrs: { id: "add-member-group-member-list", members: "" } },
          _vm._l(this.memberAlphabetList, function (group, key) {
            return _c(
              "f7-list-group",
              { key: key },
              [
                _c("f7-list-item", {
                  attrs: { title: key, "group-title": "" },
                }),
                _vm._v(" "),
                _vm._l(group, function (member) {
                  return _c(
                    "li",
                    {
                      attrs: { checked: member.checked },
                      on: {
                        change: function ($event) {
                          member.checked = $event.target.checked
                        },
                      },
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "label-checkbox item-content",
                          class: {
                            disabled:
                              member.groupLabel !== "" &&
                              member.groupId !== _vm.currentGroupId &&
                              member.groupService === _vm.currentGroupService,
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.memberSelected,
                                expression: "memberSelected",
                              },
                            ],
                            staticClass: "inputMember",
                            attrs: {
                              type: "checkbox",
                              name: "addMemberGroupMemberListCheckbox",
                            },
                            domProps: {
                              value: member.id,
                              checked: Array.isArray(_vm.memberSelected)
                                ? _vm._i(_vm.memberSelected, member.id) > -1
                                : _vm.memberSelected,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.memberSelected,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = member.id,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.memberSelected = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.memberSelected = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.memberSelected = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "item-media" }, [
                            _c("i", { staticClass: "icon icon-form-checkbox" }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "item-inner" }, [
                            _c("div", { staticClass: "item-title-row" }, [
                              _c("div", { staticClass: "item-title" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(member.login) +
                                    "\n                    "
                                ),
                                member.groupLabel !== "" &&
                                member.groupId !== _vm.currentGroupId &&
                                member.groupService === _vm.currentGroupService
                                  ? _c("div", { staticClass: "text" }, [
                                      _vm._v(
                                        "\n                      Already present in the group " +
                                          _vm._s(member.groupLabel) +
                                          "\n                    "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
              ],
              2
            )
          }),
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-start" }, [
          _c("div", { staticClass: "offset-md-3 col-md-3" }, [
            _c(
              "button",
              {
                staticClass:
                  "buttonWidth streammindContactListButton okButtonMemberList",
                on: { click: _vm.goBack },
              },
              [_c("span", [_vm._v(_vm._s(_vm.$t("common.ok")))])]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c(
              "button",
              {
                staticClass: "buttonWidth streammindContactListButton",
                on: { click: _vm.cancel },
              },
              [_c("span", [_vm._v(_vm._s(_vm.$t("common.cncl")))])]
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layoutBottomMemberList" }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "toolbarPageBottomBlank" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }